import { render, staticRenderFns } from "./OrderSop.vue?vue&type=template&id=fca2eb06"
import script from "./OrderSop.vue?vue&type=script&lang=js"
export * from "./OrderSop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports